module.exports = __webpack_public_path__ + "static/img/1.26a841f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/5/zh/1.png
// module id = tpdM
// module chunks = 0